/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var instragramH;
var layout_instagram = function () {

 if ( jQuery('.instafeed').length > 0 ) {
    setTimeout(function(){
     instragramH = $('.instafeed').height();
     jQuery('.section-links').height(instragramH);
   },500);
 }
};

var tablePlugin = function() {
  if ( jQuery('.tablepress').length > 0 ) {
    jQuery('.tablepress').wrap('<div class="article__table"></div>');
  }
};

var testimonials = function() {
  if ( jQuery('.testimonials-loop').length > 0 ) {
    jQuery('.testimonials-loop').slick({
      dots:false
    });
  }
};

var profiles = function() {
  if ( jQuery('.profiles-loop').length > 0 ) {
    jQuery('.profiles-loop').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      responsive: [
        {
          breakpoint: 9000,
          settings: "unslick"
        },
        {
          breakpoint: 991,
          settings: "slick"
        }
        ]
    });
  }
};

var services = function() {

  // Configuration for dynamic table on mobile
  if ( jQuery('.services__table').length > 0 ) {
    jQuery('.column-0').addClass('cell--visible');
  }

  jQuery('.btn[data-target="column-0"]').addClass('btn-active');

  jQuery('.services__button-section').on('click','.btn',function(e){
    e.preventDefault();
    var clicked = jQuery(this).attr('data-target');

    // Clear active cells/buttons
    jQuery('.services__button-section').find('.btn').not(this).removeClass('btn-active');
    jQuery('.mobile-headers__cell').removeClass('cell--visible');
    jQuery('.cell').removeClass('cell--visible');

    jQuery(this).addClass('btn-active');
    jQuery('.'+clicked).addClass('cell--visible');

    jQuery('.btn[data-target="' + clicked + '"]').each(function() {
      jQuery(this).addClass('btn-active');
    });
  })
};

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('html').addClass('js');
        testimonials();
        services();
        profiles();
        layout_instagram();
        tablePlugin();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
